import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() {
  }

  get(key: string): string | null {
    return localStorage.getItem(key);
  }

  set(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  setObject<U>(object: U) {
    for (const [key, value] of Object.entries(object)) {
      this.set(key, value);
    }
  }

  getObject<U>(object: U): U {
    for (const [key, value] of Object.entries(object)) {
      // @ts-ignore
      object[key] = this.get(key);
    }
    return object;
  }

  remove(key: string) {
    return localStorage.removeItem(key);
  }
  clear() {
    return localStorage.clear();
  }
}
